<div class="workshop-content">
    <h1 class="visually-hidden">Search Workshops</h1>

    <!-- Live region for dynamic updates -->
    <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true" #liveRegion></div>

    <div class="container-fluid mt-4">
        <div class="row" id="main-content">
            <div class="col-12 px-3">
                <div class="row g-4">
                    <div class="col-12">
                        <div class="card mb-0">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col-12 col-md-10 d-flex align-items-center">
                                        <i class="card-title-icon fa-solid fa-magnifying-glass material-icon-fa me-2"
                                            aria-hidden="true"></i>
                                        <h2 class="dashboard-card-title">Search Workshops</h2>
                                    </div>
                                    <div class="col-md-2 d-none d-md-flex justify-content-end">
                                        <button class="btn btn-secondary w-100 fs-6" mdbRipple
                                            routerLink="/my-workshops">
                                            My Workshops
                                        </button>
                                    </div>
                                </div>
                                <p class="dashboard-card-subtitle mt-1">Select a date range to find available workshops.
                                </p>
                                <div class="d-md-none mt-2">
                                    <button class="btn btn-secondary w-100" mdbRipple routerLink="/my-workshops">
                                        My Workshops
                                    </button>
                                </div>
                            </div>
                            <div class="card-body" role="search" aria-label="Workshop search filters">
                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-6">
                                        <div class="row align-items-center g-3">
                                            <div class="col-12 col-md-3">
                                                <mdb-form-control>
                                                    <input mdbInput [mdbDatepicker]="startDatepicker" type="text"
                                                        class="form-control" id="startDatepicker"
                                                        [formControl]="startDate" (keyup.enter)="onSearch()" />
                                                    <label mdbLabel for="startDatepicker" class="form-label">Start
                                                        Date</label>
                                                    <mdb-datepicker-toggle
                                                        [mdbDatepicker]="startDatepicker"></mdb-datepicker-toggle>
                                                    <mdb-datepicker [format]="'mm/dd/yyyy'"
                                                        #startDatepicker></mdb-datepicker>
                                                </mdb-form-control>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <mdb-form-control>
                                                    <input mdbInput [mdbDatepicker]="endDatepicker" type="text"
                                                        class="form-control" id="endDatepicker" [formControl]="endDate"
                                                        (keyup.enter)="onSearch()" />
                                                    <label mdbLabel for="endDatepicker" class="form-label">End
                                                        Date</label>
                                                    <mdb-datepicker-toggle
                                                        [mdbDatepicker]="endDatepicker"></mdb-datepicker-toggle>
                                                    <mdb-datepicker [format]="'mm/dd/yyyy'"
                                                        #endDatepicker></mdb-datepicker>
                                                </mdb-form-control>
                                            </div>
                                            <div class="col-12 col-md-3 d-flex justify-content-md-end">
                                                <button type="button" class="btn btn-primary w-100 fs-6" mdbRipple
                                                    (click)="onSearch()">Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!---->
                            </div>
                        </div>
                    </div>
                    <!-- Results section-->
                    <div class="col-12">
                        <div class="card" #resultsCard>
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <i class="card-title-icon fa-solid fa-chalkboard-user material-icon-fa me-2"
                                        aria-hidden="true"></i>
                                    <h2 class="dashboard-card-title">Search Results</h2>
                                </div>
                                <p class="dashboard-card-subtitle mt-1">Filter the available workshops below by
                                    language, format, or keyword.</p>

                            </div>
                            <div class="card-body">
                                @if (isLoading()) {
                                <div class="dashboard-empty-state">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading workshops...</span>
                                    </div>
                                </div>
                                }
                                @else if (dataSource().length > 0) {
                                <div class="row g-3 mb-4 mt-2 align-items-center justify-content-center">
                                    <!-- Keyword search -->
                                    <div class="col-12 col-md-8">
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-lg" id="search-input"
                                                #searchInput placeholder="Filter workshops by keyword..."
                                                aria-label="Filter workshops" (keyup)="search($event)" />
                                            <button class="btn btn-primary" type="button" (click)="search($event)"
                                                aria-label="Search">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- Only Show Available -->
                                    <div class="col-12 col-md-auto d-flex align-items-center">
                                        <div class="form-check form-switch mb-0">
                                            <input mdbCheckbox class="form-check-input" type="checkbox"
                                                id="showAvailable" [checked]="onlyShowAvailable()"
                                                (change)="onlyShowAvailable.set(!onlyShowAvailable())" />
                                            <label class="form-check-label  fw-semibold" for="showAvailable">Only Show
                                                Available</label>
                                        </div>
                                    </div>
                                    <!-- Reset -->
                                    <div class="col-12 col-md-auto">
                                        <div class="d-grid gap-2"></div>
                                        <button type="button" class="btn btn-primary fs-6" mdbRipple
                                            (click)="onResetFilters()">
                                            Reset
                                        </button>
                                    </div>
                                </div>


                                <!-- Table -->
                                <div class="table-responsive">
                                    <div class="datatable">
                                        <table class="table datatable-table table-hover" mdbTable mdbTableSort
                                            [fixedHeader]="true" #table="mdbTable" #sort="mdbTableSort"
                                            [dataSource]="filteredSource()" [sort]="sort" [pagination]="pagination"
                                            aria-label="Available Workshops">
                                            <thead class="datatable-header fw-bold fs-5">
                                                <tr>
                                                    @for (header of headers; track header.field) {
                                                    <th [mdbTableSortHeader]="header.field" scope="col">{{ header.label
                                                        }}</th>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody class="datatable-body fs-6">
                                                @for (workshop of table.data; track workshop.workshopSessionId) {
                                                <!-- on mobile add attributes for screen readers -->
                                                <tr scope="row" class="align-middle" [class.table-row-clickable]="isMobile()"
                                                    (click)="isMobile() && openModal(workshop)"
                                                    [attr.role]="isMobile() ? 'button' : null"
                                                    [attr.tabindex]="isMobile() ? '0' : null"
                                                    (keyup.enter)="isMobile() && openModal(workshop)">
                                                    <td class="fw-regular" [ngClass]="isMobile() ? 'date-text-wrap-balance': 'date-text-wrap'">{{formatWorkshopDateOnly(workshop.sessionStartDateTime)}}<br/>{{formatWorkshopTime(workshop.sessionStartDateTime)+ '-' + formatWorkshopTime(workshop.sessionEndDateTime)}}</td>
                                                    <td class="fw-regular">{{ workshop.topic }}</td>
                                                    <td class="fw-bold">{{ workshop.title }}</td>
                                                    <td class="fw-regular">{{ workshop.room }}</td>
                                                    <td class="fw-regular">{{ formatWorkshopMode(workshop) }}</td>
                                                    <td class="fw-regular">{{ workshop.language }}</td>
                                                    <td>
                                                        <div class="chip-outline position-relative"
                                                            [class]="getWorkshopStatusClass(workshop)">
                                                            {{ getWorkshopFriendlyStatus(workshop) | titlecase }}
                                                            <span
                                                                class="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                                                                [class]="getWorkshopSeatBadgeClass(workshop)">
                                                                <i class="fa-solid fa-chair material-icon-fa"
                                                                    aria-hidden="true"></i>&nbsp;{{
                                                                workshop.seatsRemaining }}
                                                                <span class="visually-hidden">seats remaining</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex justify-content-center">
                                                            <button type="button"
                                                                [mdbTooltip]="getWorkshopButtonText(workshop)"
                                                                [class]="getWorkshopButtonClass(workshop)"
                                                                (click)="$event.stopPropagation(); openModal(workshop)"
                                                                [attr.aria-label]="getWorkshopAriaLabel(workshop)">
                                                                <i [class]="getWorkshopButtonIcon(workshop)"
                                                                    aria-hidden="true"></i>
                                                            </button>
                                                        </div>

                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                        <mdb-table-pagination #pagination></mdb-table-pagination>
                                    </div>
                                </div>

                                }
                                @else {
                                <!-- Empty state -->
                                <div class="dashboard-empty-state  d-flex flex-column justify-content-center align-items-center" style="min-height: 400px;">
                                    <i class="fa-solid fa-chalkboard-user fa-3x material-icons" aria-hidden="true"></i>
                                    <div class="dashboard-empty-state-message">
                                        Use the filters above to search for available workshops. Results will appear
                                        here.
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <app-gradientsegmentbar></app-gradientsegmentbar>

                </div>
            </div>
        </div>
    </div>
</div>